export const defaultChargeColumns = [
  'id',
  'type',
  'accountId',
  'orderId',
  'providerReferenceId',
  'createdAt',
  'updatedAt',
  'amount',
  'refundedAmount',
  'currency',
  'authorizationCode',
  'customer.email',
  'customer.name',
  'customer.phone',
  'paymentMethod.method',
  'paymentMethod.card.brand',
  'paymentMethod.card.country',
  'paymentMethod.card.type',
  'paymentMethod.card.threeDSecure',
  'paymentMethod.card.last4',
  'paymentMethod.card.tokenizationMethod',
  'status',
  'statusCode',
  'statusMessage'
];

export const chargeColumns = [
  'id',
  'type',
  'accountId',
  'providerId',
  'checkoutId',
  'subscriptionId',
  'providerReferenceId',
  'providerInternalId',
  'createdAt',
  'updatedAt',
  'amount',
  'acquirer',
  'authorizationCode',
  'billingDetails.email',
  'billingDetails.name',
  'billingDetails.company',
  'billingDetails.taxId',
  'billingDetails.phone',
  'billingDetails.address.city',
  'billingDetails.address.country',
  'billingDetails.address.line1',
  'billingDetails.address.line2',
  'billingDetails.address.zip',
  'billingDetails.address.state',
  'currency',
  'customer.email',
  'customer.name',
  'customer.phone',
  'description',
  'descriptor',
  'livemode',
  'orderId',
  'paymentMethod.method',
  'paymentMethod.card.brand',
  'paymentMethod.card.country',
  'paymentMethod.card.type',
  'paymentMethod.card.threeDSecure',
  'paymentMethod.card.last4',
  'paymentMethod.card.tokenizationMethod',
  'refundedAmount',
  'shippingDetails.email',
  'shippingDetails.name',
  'shippingDetails.company',
  'shippingDetails.phone',
  'shippingDetails.taxId',
  'shippingDetails.address.city',
  'shippingDetails.address.country',
  'shippingDetails.address.line1',
  'shippingDetails.address.line2',
  'shippingDetails.address.zip',
  'shippingDetails.address.state',
  'shop.name',
  'shop.country',
  'status',
  'statusCode',
  'statusMessage',
  'sessionDetails.ip',
  'sessionDetails.countryCode',
  'sessionDetails.lang',
  'sessionDetails.deviceType',
  'sessionDetails.deviceModel',
  'sessionDetails.browser',
  'sessionDetails.browserVersion',
  'sessionDetails.os',
  'sessionDetails.osVersion',
  'traceDetails.ip',
  'traceDetails.countryCode',
  'traceDetails.source',
  'traceDetails.sourceVersion'
];

export type ExtraFilter =
  | 'paymentMethodBizumIntegrationType'
  | 'paymentMethodCardBrand'
  | 'amountOperator';
